import { Device } from '../../createDevice/redux/action';

export enum GetDeviceActionTypes {
  OPEN_GET_DEVICE_MODAL = 'OPEN_GET_DEVICE_MODAL',
  CLOSE_GET_DEVICE_MODAL = 'CLOSE_GET_DEVICE_MODAL',
  GET_DEVICE_REQUEST = 'GET_DEVICE_REQUEST',
  GET_DEVICE_SUCCEEDED = 'GET_DEVICE_SUCCEEDED',
  GET_DEVICE_FAILED = 'GET_DEVICE_FAILED',
}

export interface GetDeviceInput {
  id: string;
}

export interface OpenGetDeviceModal {
  type: GetDeviceActionTypes.OPEN_GET_DEVICE_MODAL;
}

export interface CloseGetDeviceModal {
  type: GetDeviceActionTypes.CLOSE_GET_DEVICE_MODAL;
}

export interface GetDeviceRequest {
  type: GetDeviceActionTypes.GET_DEVICE_REQUEST;
  id: string;
}

export interface GetDeviceSucceeded {
  type: GetDeviceActionTypes.GET_DEVICE_SUCCEEDED;
  device: Device;
}

export interface GetDeviceFailed {
  type: GetDeviceActionTypes.GET_DEVICE_FAILED;
  error: string;
}

export type GetDeviceActions =
  | OpenGetDeviceModal
  | CloseGetDeviceModal
  | GetDeviceRequest
  | GetDeviceSucceeded
  | GetDeviceFailed;

export function openGetDeviceModal(): OpenGetDeviceModal {
  return {
    type: GetDeviceActionTypes.OPEN_GET_DEVICE_MODAL,
  };
}

export function closeGetDeviceModal(): CloseGetDeviceModal {
  return {
    type: GetDeviceActionTypes.CLOSE_GET_DEVICE_MODAL,
  };
}

export function getDeviceRequest(id: string): GetDeviceRequest {
  return {
    type: GetDeviceActionTypes.GET_DEVICE_REQUEST,
    id,
  };
}

export function getDeviceSucceeded(device: Device): GetDeviceSucceeded {
  return {
    type: GetDeviceActionTypes.GET_DEVICE_SUCCEEDED,
    device,
  };
}

export function getDeviceFailed(error: string): GetDeviceFailed {
  return {
    type: GetDeviceActionTypes.GET_DEVICE_FAILED,
    error,
  };
}
